import { useCallback, useState } from 'react';

export type LocatieStatus = 'idle' | 'bezig' | 'ok' | 'fout';

/** Eigen locatie, alleen op verzoek. De positie blijft in het geheugen en wordt nergens opgeslagen of verstuurd. */
export function useLocatie() {
  const [staat, setStaat] = useState<{ status: LocatieStatus; pos: { lat: number; lng: number } | null }>({
    status: 'idle',
    pos: null,
  });

  const vraag = useCallback((klaar?: (pos: { lat: number; lng: number }) => void) => {
    if (!navigator.geolocation) {
      setStaat((s) => ({ ...s, status: 'fout' }));
      return;
    }
    setStaat((s) => ({ ...s, status: 'bezig' }));
    navigator.geolocation.getCurrentPosition(
      (p) => {
        const pos = { lat: p.coords.latitude, lng: p.coords.longitude };
        setStaat({ status: 'ok', pos });
        klaar?.(pos);
      },
      () => setStaat((s) => ({ ...s, status: 'fout' })),
      { enableHighAccuracy: false, timeout: 15_000, maximumAge: 5 * 60_000 },
    );
  }, []);

  return { ...staat, vraag };
}
